export enum SubjectType {
  COMPANY = 'company',
  FUND = 'fund',
  DEAL = 'deal',
  INVESTOR = 'investor',
  INVESTMENT_VEHICLE = 'investment-vehicle',
  INVEST = 'invest',
  TRACK = 'track',
}
